import { API_URLS } from '../configuration/apiConstants'
import { apiFetch } from '../configuration/apiFetch'

export const authSSO = (params) => {
  const fetchSettings = {
    method: 'GET',
    url: API_URLS.AUTH_SSO,
    params,
    headerParams: false,
    api: process.env.REACT_APP_AUTH,
  }
  const dataFetch = new Promise((resolve, reject) => {
    apiFetch(fetchSettings)
      .then((response) => {
        if (response.response) throw response
        resolve(response)
      })
      .catch((response) => {
        reject(new Error('Error'))
      })
  })
  return dataFetch
}

export const getMaintenance = () => {
  const fetchSettings = {
    method: 'GET',
    url: API_URLS.MAINTENANCE,
    originApp: true,
    api: process.env.REACT_APP_AUTH,
  }
  const dataFetch = new Promise((resolve) => {
    apiFetch(fetchSettings).then((response) => {
      resolve(response.maintenance)
    })
  })
  return dataFetch
}

export const getLanguages = (countryCode) => {
  const fetchSettings = {
    method: 'GET',
    url: API_URLS.LANGUAGES(countryCode),
  }
  const dataFetch = new Promise((resolve) => {
    apiFetch(fetchSettings).then((response) => {
      resolve(response)
    })
  })
  return dataFetch
}